import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/installment_from_statement';
import {apiback} from '../../../config';
import Model from '../models/installmentFromStatement.m';
import widgetsHelper from 'utils/getWidget.helper';

const installment_from_statement = 'installment_from_statement';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            selectedType: installment_from_statement,
            model: {},
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    componentWillMount() {
        fetch(apiback('PAYMENT_INSTALLMENT_FROM_STATEMENT'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new Model(json.data[installment_from_statement], this.state.selectedType)
                })
            );
        // .catch(x => console.log("error:", x)); todo добавить обработчик
    }

    componentWillReady() {
        this.widgetsHelper.getWidgets.call(this);
    }

    static displayName = 'Credit.Views.InstallmentFromStatement';

    static contextTypes = {
        app: PropTypes.object
    };
}
